import { useQuery } from '@tanstack/react-query';
import { api }  from '../lib/api';

export interface ClassItem {
  id: number;
  name: string;
  label: string;
  value: string;
}

export interface SectionItem {
  id: number;
  name: string;
  classId?: number;
  label: string;
  value: string;
}

export function useClasses() {
  return useQuery<ClassItem[]>({
    queryKey: ['classes'],
    queryFn: async () => {
      try {
        const res = await api.get<any>('/api/classes');
        const data = res.data?.data || res.data || [];
        if (Array.isArray(data)) {
          return data.map((c: any) => ({
            id: c.id || c.class_id,
            name: c.name || c.class_name || `Class ${c.id}`,
            label: c.label || c.name || `Class ${c.id}`,
            value: String(c.id || c.class_id),
          }));
        }
      } catch {
        // Fallback to hardcoded
      }
      // Default fallback
      return [
        { id: 1, name: 'Class 6', label: 'Class 6', value: '1' },
        { id: 2, name: 'Class 7', label: 'Class 7', value: '2' },
        { id: 3, name: 'Class 8', label: 'Class 8', value: '3' },
        { id: 4, name: 'Class 9', label: 'Class 9', value: '4' },
        { id: 5, name: 'Class 10', label: 'Class 10', value: '5' },
        { id: 6, name: 'Class 11', label: 'Class 11', value: '6' },
        { id: 7, name: 'Class 12', label: 'Class 12', value: '7' },
      ];
    },
    staleTime: 0,
  });
}

export function useSections(classId?: string) {
  return useQuery<SectionItem[]>({
    queryKey: ['sections-for-class', classId],
    queryFn: async () => {
      if (!classId) return [];
      try {
        const res = await api.get<any>(`/api/sections?classId=${classId}`);
        const data = res.data?.data || res.data || [];
        if (Array.isArray(data)) {
          return data.map((s: any) => ({
            id: s.id || s.section_id,
            name: s.name || s.section_name || `Section ${s.id}`,
            classId: s.class_id || parseInt(classId),
            label: s.label || s.name || `Section ${s.id}`,
            value: String(s.id || s.section_id),
          }));
        }
      } catch {
        // Fallback
      }
      // Default fallback based on class
      return [
        { id: 1, name: 'A', label: 'A', value: '1', classId: parseInt(classId) },
        { id: 2, name: 'B', label: 'B', value: '2', classId: parseInt(classId) },
      ];
    },
    enabled: !!classId,
    staleTime: 0,
  });
}
